import { ReactElement } from "react";

export const MachineManagementIcon = (color?: string): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.0175 12.1869C19.1881 11.4843 20.1872 11.4843 20.3578 12.1869C20.468 12.6407 20.9879 12.8561 21.3868 12.6131C22.0042 12.2369 22.7107 12.9435 22.3345 13.5608C22.0915 13.9597 22.3069 14.4796 22.7607 14.5898C23.4633 14.7604 23.4633 15.7596 22.7607 15.9301C22.3069 16.0403 22.0915 16.5603 22.3345 16.9591C22.7107 17.5765 22.0042 18.283 21.3868 17.9068C20.9879 17.6638 20.468 17.8792 20.3578 18.333C20.1872 19.0356 19.1881 19.0356 19.0175 18.333C18.9073 17.8792 18.3873 17.6638 17.9885 17.9068C17.3711 18.283 16.6646 17.5765 17.0408 16.9591C17.2838 16.5603 17.0684 16.0403 16.6146 15.9301C15.912 15.7596 15.912 14.7604 16.6146 14.5898C17.0684 14.4796 17.2838 13.9597 17.0408 13.5608C16.6646 12.9435 17.3711 12.2369 17.9885 12.6131C18.3873 12.8561 18.9073 12.6407 19.0175 12.1869Z"
        stroke={color ? color : '#000000'}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8876 15.26C20.8876 15.9227 20.3504 16.46 19.6876 16.46C19.0249 16.46 18.4876 15.9227 18.4876 15.26C18.4876 14.5972 19.0249 14.06 19.6876 14.06C20.3504 14.06 20.8876 14.5972 20.8876 15.26Z"
        stroke={color ? color : '#000000'}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_2571_463"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="2"
        width="20"
        height="20"
      >
        <path
          d="M8.49998 16.803L7.77554 19.7008L6.80961 20.6667H14.537L13.5711 19.7008L12.8466 16.803M1.97998 12.9393H19.3666M3.91183 16.803H17.4348C18.5017 16.803 19.3666 15.9381 19.3666 14.8711V5.21188C19.3666 4.14495 18.5017 3.28003 17.4348 3.28003H3.91183C2.8449 3.28003 1.97998 4.14495 1.97998 5.21188V14.8711C1.97998 15.9381 2.8449 16.803 3.91183 16.803Z"
          stroke={color ? color : '#000000'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_2571_463)">
        <path
          d="M1.01416 0.382263H24.6793V10.0415H14.5371V17.7689L15.503 18.7349V21.6326H1.01416V0.382263Z"
          fill={color ? color : '#000000'}
        />
      </g>
    </svg>
  );
};
